import DefaultMenuExpenses from "./MenuExpenses";

export default DefaultMenuExpenses;
